
webpack.register(
    'modules/history-experience-collections/history-experience-collections',
    function() {
        return import('modules/history-experience-collections/history-experience-collections');
    },
    true
);